<template>
    <div>
        <buttonlist
                @help="help"
                @reflash="reflash"
                ref="SetBtn"
        ></buttonlist>
        <div id="xpane-0">
            <vxe-table
                ref="singleTable"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                resizable
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:2px"
        >
            <vxe-table-column show-overflow-tooltip field="configtype" :title="$t('getapi[8073]')" width="80">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="oip" :title="$t('getapi[8074]')" width="100">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="iip" :title="$t('getapi[8075]')" width="100">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="location" :title="$t('getapi[8060]')" width="120">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="sublocation" :title="$t('getapi[8061]')" width="120">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="field" :title="$t('getapi[8062]')" width="50">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="sharedip" :title="$t('getapi[8063]')" width="80">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="sharedlocation" :title="$t('getapi[8064]')" width="120">
            </vxe-table-column>
            <!-- <vxe-table-column show-overflow-tooltip field="iisname" :title="$t('getapi[8065]')"  width="80">
            </vxe-table-column> -->
            <vxe-table-column show-overflow-tooltip field="username" :title="$t('getapi[8066]')" width="80">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="password" :title="$t('getapi[8067]')" width="80">
            </vxe-table-column>
            <!-- <vxe-table-column show-overflow-tooltip field="type" :title="$t('getapi[8068]')" width="80">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="data_type" :title="$t('getapi[8069]')" width="50">
            </vxe-table-column> -->
            <vxe-table-column show-overflow-tooltip field="description" :title="$t('getapi[8070]')" width="120">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="remark" :title="$t('getapi[8071]')" width="150">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip :title="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope.row)" type="text" size="small">
                        {{$t('getapi[34]')}}
                    </el-button>
                </template>
            </vxe-table-column>
        </vxe-table>
        </div>
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[8825]')" width="30%">
            <!--<el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="110px"
                             label-position="left" size="small">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8073]')">
                                    <el-input v-model="dataDetail.configtype" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8074]')">
                                    <el-input v-model="dataDetail.oip"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8075]')">
                                    <el-input v-model="dataDetail.iip"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8060]')">
                                    <el-input v-model="dataDetail.location"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8061]')">
                                    <el-input v-model="dataDetail.sublocation"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8063]')">
                                    <el-input v-model="dataDetail.sharedip"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8064]')">
                                    <el-input v-model="dataDetail.sharedlocation"></el-input>
                                </el-form-item>
                            </el-col>
                          
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8066]')">
                                    <el-input v-model="dataDetail.username"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8067]')">
                                    <el-input v-model="dataDetail.password"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8070]')">
                                    <el-input v-model="dataDetail.description"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8071]')">
                                    <el-input v-model="dataDetail.remark"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>

            </el-row>-->
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[8073]')}}</td>
                        <td><el-input v-model="dataDetail.configtype" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8074]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.oip"></el-input>
                        </td>
                        <td>{{$t('getapi[8075]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.iip"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8060]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.location"></el-input>
                        </td>
                        <td>{{$t('getapi[8061]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.sublocation"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8063]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.sharedip"></el-input>
                        </td>
                        <td>{{$t('getapi[8064]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.sharedlocation"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8066]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.username"></el-input>
                        </td>
                        <td>{{$t('getapi[8067]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.password"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8070]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.description"></el-input>
                        </td>
                        <td>{{$t('getapi[8071]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.remark"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'filesconfig',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                DbTbNames: '',
                loading: false, // 主表加载状态
                dataDetail: {
                    configtype:'',
                    oip:'',
                    iip:'',
                    location:'',
                    sublocation:'',
                    field:'',
                    sharedip:'',
                    sharedlocation:'',
                    iisname:'',
                    username:'',
                    password:'',
                    type:0,
                    data_type:0,
                    description:'',
                    remark:''
                },
                positionKey: '', //查询
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView(),
                that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8056]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetButtonEnable('refresh');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let data = {};
                that.$http.urlpost('/Sys/Currency/GetFileConfigInfo', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.Table;
                        that.loading = false;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
                that.authority();
            },
            // 编辑
            edit(row) {
                let that = this
                that.isVisible = true
                that.dataDetail.configtype = row.configtype
                that.dataDetail.oip = row.oip
                that.dataDetail.iip = row.iip
                that.dataDetail.location = row.location
                that.dataDetail.sublocation = row.sublocation
                that.dataDetail.field = row.field
                that.dataDetail.sharedip = row.sharedip
                that.dataDetail.sharedlocation = row.sharedlocation
                that.dataDetail.iisname = row.iisname
                that.dataDetail.username = row.username
                that.dataDetail.password = row.password
                that.dataDetail.type = row.type
                that.dataDetail.data_type = row.data_type
                that.dataDetail.description = row.description
                that.dataDetail.remark = row.remark
            },
            //保存
            save(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Sys/Currency/SaveFileConfigInfo', parm, function(res) {
                    if(res.Success == 1){
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisible = false
                        that.getView()
                    }
                });
            },
            // 查询
            confirmSearchPosition(){
                let that = this
                if(that.positionKey == ''){
                    return
                }
                let row = null
                for(let i =0;i<that.dataSet.length;i++){
                    if(that.positionKey.toUpperCase() == that.dataSet[i].Chinese.toUpperCase()){
                        row = that.dataSet[i]
                    }
                }
                if(row != null){
                    that.$refs.singleTable.setCurrentRow(row);
                    setTimeout(() => {
                        this.$refs.singleTable.scrollToRow(row)
                    }, 200);
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
